import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { ParticipantSubHeader } from 'components/sections/assessor'
import { apiAssessors } from 'helpers/decorators/api'
import { renderRoutes } from 'react-router-config'
import config from 'config'

@apiAssessors()
@connect((state, props) => {
  let activeActivity = null
  const activeAward = get(
    props,
    'assessor.participants.list',
    []
  ).find(participant => {
    activeActivity = get(participant, 'activities', []).find(
      activity =>
        get(activity, 'id') === Number(get(props, 'params.activityId'))
    )
    return activeActivity
  })
  const activeParticipant = get(activeAward, 'participant')
  const activeOrganization = get(activeAward, 'organization')

  return {
    activeAward,
    activeOrganization,
    activeActivity,
    activeParticipant
  }
})
class ActivityDetailAssessor extends Component {
  static propTypes = {
    route: PropTypes.object,
    activeAward: PropTypes.object,
    activeOrganization: PropTypes.object,
    activeActivity: PropTypes.object,
    activeParticipant: PropTypes.object,
    params: PropTypes.object
  }

  render() {
    const {
      activeAward,
      activeOrganization,
      activeActivity,
      activeParticipant,
      route,
      params
    } = this.props

    return (
      <div>
        <ParticipantSubHeader
          activityRoute={`${config.publicPath}/assessor/activity/${params.activityId}`}
          activitySection={get(activeActivity, 'activitySection.value')}
          avatar={get(activeParticipant, 'photoUrl')}
          completedPercentage={get(activeActivity, 'completedPercentage')}
          completionText={get(activeActivity, 'completionText')}
          isMajor={get(activeActivity, 'isMajor')}
          name={get(activeParticipant, 'name')}
        />
        {route && renderRoutes(route.routes, {
          activity: activeActivity,
          award: activeAward,
          participant: activeParticipant,
          organization: activeOrganization,
          isAssessor: true
        })}
      </div>
    )
  }
}

export default ActivityDetailAssessor
